import apiClient from './api';
import { Notification } from '../types'; // تأكد من أن هذا النوع موجود في types/index.ts
import { NotificationType } from '../types/enums'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لإنشاء تنبيه جديد
export interface NewNotificationData {
  user_id: number;
  title: string;
  message: string;
  type: NotificationType;
}
// نوع البيانات التي تعيدها بعض مسارات الـ API
interface ApiResponse<T> {
  success: boolean;
  data: T;
  
}

interface UnreadCountResponse {
  unread_count: number;
}

/**
 * جلب إشعارات المستخدم الحالي
 * @param userId - معرف المستخدم
 */
export const getMyNotifications = async (userId: number): Promise<Notification[]> => {
  const response = await apiClient.get<ApiResponse<Notification[]>>(`/notifications/user/${userId}`);
  return response.data.data;
};

/**
 * جلب عدد الإشعارات غير المقروءة للمستخدم الحالي
 * @param userId - معرف المستخدم
 */
export const getUnreadCount = async (userId: number): Promise<number> => {
  const response = await apiClient.get<ApiResponse<UnreadCountResponse>>(`/notifications/user/${userId}/unread-count`);
  return response.data.data.unread_count;
};

/**
 * وضع علامة "مقروء" على إشعار معين
 * @param notificationId - معرف الإشعار
 */
export const markAsRead = async (notificationId: number): Promise<Notification> => {
  const response = await apiClient.patch<ApiResponse<Notification>>(`/notifications/${notificationId}/read`);
  return response.data.data;
};

/**
 * وضع علامة "مقروء" على كل إشعارات المستخدم
 * @param userId - معرف المستخدم
 */
export const markAllAsRead = async (userId: number): Promise<Notification[]> => {
  const response = await apiClient.patch<ApiResponse<Notification[]>>(`/notifications/user/${userId}/read-all`);
  return response.data.data;
};

export const getPagedNotifications = async (params: TableParams): Promise<PagedResult<Notification>> => {
  const response = await apiClient.get<{ data: PagedResult<Notification> }>('/notifications/paged', { params });
  return response.data.data;
};

/**
 * جلب تنبيه بواسطة ID
 */
export const getNotificationById = async (id: number): Promise<Notification> => {
  const response = await apiClient.get<{ data: Notification }>(`/notifications/${id}`);
  return response.data.data;
};

/**
 * إنشاء تنبيه جديد
 */
export const createNotification = async (notificationData: NewNotificationData): Promise<Notification> => {
  const response = await apiClient.post<{ data: Notification }>('/notifications', notificationData);
  return response.data.data;
};

/**
 * حذف تنبيه بواسطة ID
 */
export const deleteNotification = async (id: number): Promise<void> => {
  await apiClient.delete(`/notifications/${id}`);
};
